<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <v-card class='elevation-2 animated fadeIn'>
                    <v-toolbar flat>
                        <v-toolbar-title>Monitoria</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-stepper v-model="currentStep">
                            <v-stepper-header>
                                <v-stepper-step :complete="currentStep > 1" step="1">Escuela</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="currentStep > 2" step="2">Estudiante</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step step="3">Transacción</v-stepper-step>
                            </v-stepper-header>
                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" v-on:click="getAllSchools"><v-icon>refresh</v-icon> Refrescar</v-btn>
                                    </v-layout>
                                    <v-text-field v-model="searchSchools"
                                                  append-icon="search"
                                                  label="Buscar"
                                                  single-line
                                                  hide-details></v-text-field>
                                    <v-data-table :headers="schoolsHeaders"
                                                  :items="schools"
                                                  :search="searchSchools"
                                                  :loading="schoolsLoading"
                                                  no-data-text="No hay datos disponibles aun por favor espere mientras se cargan..."
                                                  rows-per-page-text="Filas por página"
                                                  :rows-per-page-items='[5,10,20,25,{"text":"Todos","value":-1}]'
                                                  class="elevation-1">
                                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <td>{{ props.item.REGION_NAME }}</td>
                                            <td class="text-xs-left">{{ props.item.MUNICIPALITY }}</td>
                                            <td class="text-xs-left">{{ props.item.SCHOOL_NAME }}</td>
                                            <td class="text-xs-left">{{ props.item.SCHOOL_CODE }}</td>
                                            <td class="text-xs-center"><v-btn color="success" small fab v-on:click="selectSchool(props)"><v-icon>done_outline</v-icon></v-btn></td>
                                            <td class="text-xs-center"><v-btn color="warning" small fab v-on:click="downloadReport(props)"><v-icon>cloud_download</v-icon></v-btn></td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            Su búsqueda por "{{ searchSchools }}" no encontro resultados.
                                        </v-alert>
                                    </v-data-table>
                                </v-stepper-content>
                                <v-stepper-content step="2">
                                    <v-layout row>
                                        <v-btn color="primary" v-on:click.native="currentStep = 1, searchSchools =''"><v-icon>arrow_back</v-icon> Atrás</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" v-on:click="getStudentsTransactionsBySchoolIdAsync"><v-icon>refresh</v-icon> Refrescar</v-btn>
                                    </v-layout>
                                    <v-alert dark :value="true" color="success" icon="new_releases">
                                        <p><strong>Escuela</strong> {{ selectedSchool.SCHOOL_CODE }} - {{ selectedSchool.SCHOOL_NAME }}</p>
                                    </v-alert>
                                    <v-text-field v-model="searchStudents"
                                                  append-icon="search"
                                                  label="Buscar"
                                                  single-line
                                                  hide-details></v-text-field>
                                    <v-data-table :headers="studentsHeaders"
                                                  :items="students"
                                                  :search="searchStudents"
                                                  :loading="studentsLoading"
                                                  no-data-text="No hay datos disponibles aun por favor espere mientras se cargan..."
                                                  rows-per-page-text="Filas por página"
                                                  :rows-per-page-items='[5,10,20,25,{"text":"Todos","value":-1}]'
                                                  class="elevation-1">
                                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <td>{{ props.item.GRADE }}</td>
                                            <td class="text-xs-left">{{ props.item.STUDENT_ID }}</td>
                                            <td class="text-xs-left">{{ props.item.FULL_LAST_NAME }}</td>
                                            <td class="text-xs-left">{{ props.item.FIRST_NAME }}</td>
                                            <td class="text-xs-left">{{ props.item.MIDDLE_NAME }}</td>
                                            <td class="text-xs-rigth">{{ props.item.TRANSACTION_CODE }}</td>
                                            <td class="text-xs-rigth">{{ (props.item.HAS_EVIDENCE) ? 'Sí': 'No' }}</td>
                                            <td class="text-xs-rigth">{{ props.item.TRANSACTION_STATUS_DESC }}</td>
                                            <td class="text-xs-center"><v-btn color="success" small fab v-on:click="selectStudent(props)"><v-icon>done_outline</v-icon></v-btn></td>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            Su búsqueda por "{{ searchStudents }}" no encontro resultados.
                                        </v-alert>
                                    </v-data-table>
                                </v-stepper-content>
                                <v-stepper-content step="3">
                                    <v-layout row>
                                        <v-btn color="primary" v-on:click.native="currentStep = 2,searchStudents =''"><v-icon>arrow_back</v-icon> Atrás</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" v-on:click="getStudentsTransactionsDetailsByStudentId"><v-icon>refresh</v-icon> Refrescar</v-btn>
                                    </v-layout>
                                    <v-alert dark :value="true" color="success" icon="new_releases">
                                        <p><strong>Escuela</strong> {{ selectedSchool.SCHOOL_CODE }} - {{ selectedSchool.SCHOOL_NAME }}</p>
                                        <p><strong>Estudiante</strong> {{ selectedStudent.STUDENT_ID }} - {{ selectedStudent.FULL_LAST_NAME + ' ' +  selectedStudent.FIRST_NAME + ' ' + ((selectedStudent.MIDDLE_NAME != null) ? selectedStudent.MIDDLE_NAME: '') }}</p>
                                    </v-alert>
                                    <v-data-table :headers="studentTransactionsHeaders"
                                                  :items="studentTransactionsDetails"
                                                  :loading="studentsTransactionsLoading"
                                                  no-data-text="No hay datos disponibles aun por favor espere mientras se cargan..."
                                                  rows-per-page-text="Filas por página"
                                                  :rows-per-page-items='[{"text":"Todos","value":-1}]'
                                                  class="elevation-1">
                                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <td>{{ props.item.TRANSACTION_DATE | formatDate }}</td>
                                            <td class="text-xs-left">{{ props.item.TRANSACTION_DESCRIPTION }}</td>
                                            <td class="text-xs-left">
                                                <v-radio-group v-model="props.item.HAS_EVIDENCE" :mandatory="false">
                                                    <v-radio v-on:change="enabledEvidence = false" label="Sí" :value="true"></v-radio>
                                                    <v-radio v-on:change="enabledEvidence = true" label="No" :value="false"></v-radio>
                                                </v-radio-group>
                                            </td>
                                            <td class="text-xs-left">
                                                <v-checkbox :disabled="enabledEvidence"
                                                            v-for="(option, index) in props.item.EVIDENCES"
                                                            :key="index"
                                                            v-model="option.Evidence_References"
                                                            :label="option.EVIDENCE_DESCRIPTION"
                                                            :value="option.EVIDENCE_ID_FK"
                                                            hide-details></v-checkbox>
                                                <!-- <NativeSelect v-model="props.item.transactionsSelected"
                                                          id="EVIDENCE_ID_FK"
                                                          name="EVIDENCE_ID_FK"
                                                          label="Seleccione las evidencias"
                                                          placeholder=""
                                                          :multiple="true"
                                                          :items="props.item.EVIDENCES"
                                                          item-text="EVIDENCE_DESCRIPTION"
                                                          item-value="EVIDENCE_ID_FK">
                                                </NativeSelect> -->
                                                <!--<v-container fluid>
                                                <v-switch v-model="props.item.transactionsSelected"
                                                          v-for="(Evidence, index) in props.item.transactionsEvidenceList"
                                                          :label="Evidence.EVIDENCE_DESCRIPTION"
                                                          :value="Evidence.EVIDENCE_ID">
                                                </v-switch>
                                                </v-container>-->
                                                <!--Verificar cual es el value que necesito-->
                                                <!--<v-checkbox v-for="(Evidence, index) in props.item.transactionsEvidenceList"
                                                            v-model="props.item.transactionsEvidenceList[props.index].selected"
                                                            :label="Evidence.EVIDENCE_DESCRIPTION"
                                                            :value="Evidence.EVIDENCE_ID">
                                                </v-checkbox>-->
                                                <!--<v-flex xs12 class="py-2">
                                                    <v-btn-toggle v-model="props.item.transactionsSelected" multiple>
                                                        <v-btn v-for="(option, index) in props.item.EVIDENCES" v-model="option.EVIDENCE_ID_FK" :key="option.EVIDENCE_ID_FK">
                                                            {{ option.EVIDENCE_DESCRIPTION }}
                                                        </v-btn>
                                                    </v-btn-toggle>
                                                </v-flex>-->
                                            </td>
                                            <td class="">
                                                <!--<v-text-field v-model="props.item.COMMENT"
                                                              id="COMMENT"
                                                              name="COMMENT"
                                                              multi-line>
                                                </v-text-field>-->
                                                <v-text-field v-model="props.item.COMMENT"
                                                              id="COMMENT"
                                                              name="COMMENT"
                                                              multi-line
                                                              color="cyan darken"
                                                              placeholder="Ingrese comentario">
                                                    <template v-slot:progress>
                                                        <v-progress-linear v-if="custom"
                                                                           :value="progress"
                                                                           :color="color"
                                                                           absolute
                                                                           height="7"></v-progress-linear>
                                                    </template>
                                                </v-text-field>

                                            </td>
                                            <td class="text-xs-rigth">
                                                <NativeSelect v-model="props.item.TRANSACTION_STATUS_ID_FK"
                                                              id="TRANSACTION_STATUS_ID_PK"
                                                              name="TRANSACTION_STATUS_ID_PK"
                                                              label=""
                                                              placeholder=""
                                                              :items="props.item.transactionsStatusList"
                                                              item-text="TRANSACTION_STATUS_DESCRIPTION"
                                                              item-value="TRANSACTION_STATUS_ID_PK">
                                                </NativeSelect>
                                            </td>
                                            <td class="text-xs-center">
                                                <v-btn :loading="loadingAction"
                                                       :disabled="loadingAction"
                                                       color="success"
                                                       small
                                                       fab
                                                       v-on:click="saveStudentTransaction(props.item, $event)">
                                                    <v-icon>done_outline</v-icon>
                                                </v-btn>
                                            </td>
                                        </template>
                                    </v-data-table>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-card-text>
                    <v-card-actions>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import script from './script'
    export default script
</script>


// WEBPACK FOOTER //
// src/components/monitoria/transaccion/component.vue